import React,{useEffect,useState} from 'react';
import {useNavigate,useParams} from 'react-router-dom';
import api from '../services/api';

import Loading from '../components/Loading';
const modeLabel={STAKE:'Stake',TOURNAMENT:'Tournament',FRIENDS_ROOM:'Friends Room'};
const resultLabel={WINNER:'Won',ELIMINATED:'Eliminated',FINISHED:'Finished',FORFEITED:'Forfeited',DISQUALIFIED:'Disqualified',TIMED_OUT:'Timed out'};
const money=n=>n==null?null:`₦${Number(n).toLocaleString('en-NG',{minimumFractionDigits:2,maximumFractionDigits:2})}`;
const dateTime=v=>v?new Date(v).toLocaleString('en-NG',{dateStyle:'medium',timeStyle:'short'}):null;
const duration=ms=>ms==null?null:`${Math.floor(ms/60000)}m ${Math.floor((ms%60000)/1000)}s`;
const prettyType=v=>String(v||'').replaceAll('_',' ').replace(/\\b\\w/g,c=>c.toUpperCase());

function PageState({children}){return <div style={page}><button onClick={()=>history.back()} style={back}>← Back</button>{children}</div>}

export default function GameHistory(){
  const {recordType,recordId}=useParams(); const navigate=useNavigate();
  const detail=Boolean(recordType&&recordId);
  const [loading,setLoading]=useState(true),[error,setError]=useState(''),[history,setHistory]=useState(null),[match,setMatch]=useState(null);
  const [offset,setOffset]=useState(0);
  const limit=20;

  useEffect(()=>{let live=true;setLoading(true);setError('');
    const request=detail?api.gameHistory.getMatch(recordType,recordId):api.gameHistory.list({limit,offset});
    request.then(r=>{if(!live)return; if(detail)setMatch(r.data?.data?.match||null);else setHistory(r.data?.data?.history||null)})
      .catch(e=>{if(live)setError(e.response?.data?.message||'Unable to load Game History.')})
      .finally(()=>live&&setLoading(false));
    return()=>{live=false};
  },[detail,recordType,recordId,offset]);

  if(loading)return <PageState><section style={card}><div style={title}>🎮 Game History</div><Loading variant="section" label="" /></section></PageState>;
  if(error)return <PageState><section style={card}><div style={title}>{detail?'🎮 Match Details':'🎮 Game History'}</div><div style={errorBox}>{error}</div></section></PageState>;
  if(detail)return <PageState><MatchDetails match={match} navigate={navigate}/></PageState>;

  const items=history?.matches||[];
  return <PageState>
    <section style={card}>
      <div style={title}>🎮 Game History</div>
      <div style={muted}>{history?.total??0} recorded WHOT games</div>
      {items.length===0?<div style={empty}><div style={{fontSize:34}}>🎮</div><div style={{fontWeight:900,marginTop:8}}>No historical records</div><div style={muted}>Your recorded WHOT games will appear here.</div></div>:
        <div style={{display:'grid',gap:10,marginTop:16}}>{items.map(item=><HistoryItem key={item.recordIdType+':'+item.recordId} item={item} onClick={()=>navigate('/game-history/'+encodeURIComponent(item.mode)+'/'+encodeURIComponent(item.recordId))}/>)}</div>}
      {history&&history.total>offset+items.length&&<button style={loadMore} onClick={()=>setOffset(offset+limit)}>Load more</button>}
    </section>
  </PageState>;
}

export function HistoryItem({item,onClick}){
  const opponentNames=(item.opponents||[]).map(o=>o.username).filter(Boolean);
  const financialLines=[];
  if(item.payout!=null)financialLines.push(['Winnings',money(item.payout)]);
  if(item.refund!=null)financialLines.push(['Refund',money(item.refund)]);
  if(item.amountLost!=null)financialLines.push(['Loss','-'+money(item.amountLost)]);
  return <button onClick={onClick} style={itemBtn}>
    <div style={{display:'flex',justifyContent:'space-between',gap:12,alignItems:'flex-start'}}>
      <div style={{minWidth:0,textAlign:'left'}}>
        <div style={{fontWeight:900}}>🃏 WHOT</div>
        <div style={muted}>{modeLabel[item.mode]||item.mode}{opponentNames.length?' · '+opponentNames.join(', '):item.mode==='TOURNAMENT'?' · Individual play':''}</div>
        <div style={small}>{dateTime(item.completedAt||item.createdAt)||'Date unavailable'}</div>
      </div>
      <div style={{textAlign:'right',whiteSpace:'nowrap'}}>{item.outcome&&<div style={outcomeStyle(item.outcome)}>{item.outcome}</div>}{financialLines.map(([label,value])=><div key={label} style={{fontWeight:900,marginTop:4}}>{label}: {value}</div>)}</div>
    </div>
    <div style={metaRow}>
      {item.entryFee!=null&&<span>{money(item.entryFee)} entry</span>}
      {item.score!=null&&<span>Score {item.score}</span>}
      {item.rank!=null&&<span>Rank {item.rank}</span>}
    </div>
  </button>
}

export function MatchDetails({match,navigate}){
  if(!match)return <section style={card}><div style={title}>🎮 Match Details</div><div style={muted}>Game history record not found.</div></section>;
  return <section style={card}>
    <div style={title}>🎮 Match Details</div>
    <div style={idBox}><div style={labelStyle}>Match ID</div><div style={idText}>{match.recordId}</div><div style={small}>{match.recordIdType}</div></div>
    <div style={grid}>
      <Field label="Game" value="WHOT"/>
      <Field label="Mode" value={modeLabel[match.mode]||match.mode}/>
      <Field label="Status" value={match.status}/>
      <Field label="Result" value={resultLabel[match.result]||match.result}/>
      <Field label="Entry / Stake" value={money(match.entryFee)}/>
      <Field label="Score" value={match.score}/>
      <Field label="Rank" value={match.rank}/>
      <Field label="Duration" value={duration(match.durationMs)}/>
      <Field label="Started" value={dateTime(match.startedAt)}/>
      <Field label="Completed" value={dateTime(match.completedAt)}/>
      <Field label="Winnings" value={money(match.payout)}/>
      <Field label="Refund" value={money(match.refund)}/>
      <Field label="Loss" value={money(match.amountLost)}/>
      <Field label="Net outcome" value={money(match.netOutcome)}/>
      <Field label="Missed Turns" value={match.missedTurns}/>
    </div>
    {match.opponents?.length>0&&<section style={sub}><div style={sectionTitle}>Opponents</div>{match.opponents.map((o,i)=><div key={String(o.userId||'unknown')+i} style={row}><span>{o.username||'Opponent information unavailable'}</span><span style={muted}>{o.result?resultLabel[o.result]||o.result:''}{o.score!=null?' · Score '+o.score:''}</span></div>)}</section>}
    {match.mode==='TOURNAMENT'&&match.tournament&&<section style={sub}><div style={sectionTitle}>Tournament</div><Field label="Tournament" value={match.tournament.name}/><Field label="Play" value={match.tournament.playNumber}/></section>}
    {match.mode==='FRIENDS_ROOM'&&match.room&&<section style={sub}><div style={sectionTitle}>Friends Room</div><Field label="Room" value={match.room.code||null}/></section>}
  </section>
}

function Field({label,value}){return <div style={field}><div style={labelStyle}>{label}</div><div style={valueStyle}>{value==null||value===''?'—':String(value)}</div></div>}

const page={maxWidth:820,margin:'0 auto',padding:'18px 16px 40px',color:'#fff'};
const back={background:'transparent',border:0,color:'#ddd',fontWeight:800,cursor:'pointer',padding:'4px 0 14px'};
const card={background:'#111',border:'1px solid #252525',borderRadius:18,padding:20};
const title={fontSize:20,fontWeight:950};
const sectionTitle={fontWeight:900,marginBottom:12};
const muted={color:'#777',fontSize:12};
const small={color:'#666',fontSize:11,marginTop:5};
const empty={textAlign:'center',padding:'45px 10px',color:'#aaa'};
const itemBtn={width:'100%',textAlign:'left',background:'#0d0d0d',border:'1px solid #252525',borderRadius:14,color:'#fff',padding:14,cursor:'pointer'};
const metaRow={display:'flex',flexWrap:'wrap',gap:8,marginTop:12,color:'#aaa',fontSize:11};
const loadMore={display:'block',margin:'16px auto 0',background:'#171717',border:'1px solid #3a3a3a',color:'#fff',borderRadius:9,padding:'9px 14px',fontWeight:800,cursor:'pointer'};
const errorBox={background:'rgba(239,68,68,.12)',color:'#fca5a5',border:'1px solid rgba(239,68,68,.35)',borderRadius:10,padding:12,marginTop:14};
const idBox={background:'#0d0d0d',border:'1px solid #252525',borderRadius:12,padding:12,marginTop:16};
const idText={fontFamily:'monospace',fontSize:12,wordBreak:'break-all',marginTop:5};
const grid={display:'grid',gridTemplateColumns:'repeat(2,minmax(0,1fr))',gap:9,marginTop:12};
const field={background:'#0d0d0d',border:'1px solid #252525',borderRadius:11,padding:10,minWidth:0};
const labelStyle={fontSize:10,color:'#666',textTransform:'uppercase',letterSpacing:.6};
const valueStyle={fontSize:13,fontWeight:800,marginTop:4,wordBreak:'break-word'};
const sub={marginTop:18,paddingTop:16,borderTop:'1px solid #252525'};
const row={display:'flex',justifyContent:'space-between',gap:12,padding:'9px 0',borderBottom:'1px solid #1e1e1e',fontSize:12};
const eventRow={background:'#0d0d0d',border:'1px solid #252525',borderRadius:11,padding:10};
const outcomeStyle=outcome=>({fontWeight:900,color:outcome==='Won'?'#4ade80':outcome==='Loss'?'#f87171':'#fbbf24'});
